import "./BoxScoreDetails.css";

import { ISoccerMatch } from "../../../../../../types";
import { TOURNAMENT_ID } from "../../../../config/tournament";
import { useMatchResult } from "../../../../hooks";
import { openSbsOnDemand, SbsAnalyticsService } from "../../../../utils";
import { BoxScoreEvents } from "../BoxScoreEvents";
import { MatchStartCountdown } from "../MatchStartCountdown";
import { MoreInformation } from "../MoreInformation";

export const BoxScoreDetails = ({
  soccerMatch,
}: {
  soccerMatch: ISoccerMatch;
}) => {
  const { isMatchNotStarted, isMatchPlaying } = useMatchResult({ soccerMatch });
  // "Stream Live" for live/in-progress matches, "Stream Now" once full-time.
  const ctaLabel = isMatchNotStarted || isMatchPlaying ? "Stream Live" : "Stream Now";
  const ctaState = isMatchNotStarted ? "pre" : isMatchPlaying ? "live" : "post";

  return (
    <div className="box-score-details">
      {isMatchNotStarted ? (
        <>
          {!!soccerMatch.matchDateTime && (
            <MatchStartCountdown matchStartTime={soccerMatch.matchDateTime} />
          )}
          <MoreInformation soccerMatch={soccerMatch} />
        </>
      ) : (
        <BoxScoreEvents soccerMatch={soccerMatch} />
      )}
      <button
        className="watch-replay-btn"
        onClick={() => {
          const event = isMatchPlaying
            ? "stream_live_on_demand"
            : "stream_now_on_demand";
          SbsAnalyticsService.trackEvent(event, {
            match_id: soccerMatch.id,
            tournament_id: TOURNAMENT_ID,
          });
          openSbsOnDemand({ placement: "matchcentre", state: ctaState });
        }}
      >
        <span>{ctaLabel}</span>
        <img src="/images/match-events/on-demand.svg" alt="On Demand" />
      </button>
    </div>
  );
};
